// 역할/권한 상수 및 유틸

export const Roles = {
    OPERATOR: 'OPERATOR',
    // GA (master/unit/branch)
    GA_MASTER_ADMIN: 'GA_MASTER_ADMIN',
    GA_MASTER_DEPUTY_ADMIN: 'GA_MASTER_DEPUTY_ADMIN',
    GA_LEADER: 'GA_LEADER',
    GA_DEPUTY_LEADER: 'GA_DEPUTY_LEADER',
    GA_MANAGER: 'GA_MANAGER',
    GA_PLANNER: 'GA_PLANNER',
    GA_BRANCH_MANAGER: 'GA_BRANCH_MANAGER',
    GA_DEPUTY_BRANCH_MANAGER: 'GA_DEPUTY_BRANCH_MANAGER',
    GA_OTHER_ADMIN: 'GA_OTHER_ADMIN',
    GA_ETC: 'GA_ETC',
    // INSURER (master/unit/branch)
    INSURER_MASTER_ADMIN: 'INSURER_MASTER_ADMIN',
    INSURER_MASTER_DEPUTY_ADMIN: 'INSURER_MASTER_DEPUTY_ADMIN',
    INSURER_MANAGER: 'INSURER_MANAGER',
    INSURER_LEADER: 'INSURER_LEADER',
    INSURER_DEPUTY_LEADER: 'INSURER_DEPUTY_LEADER',
    INSURER_BRANCH_MANAGER: 'INSURER_BRANCH_MANAGER',
    INSURER_DEPUTY_BRANCH_MANAGER: 'INSURER_DEPUTY_BRANCH_MANAGER',
    INSURER_EDUCATION_MANAGER: 'INSURER_EDUCATION_MANAGER',
    INSURER_PLAN_MANAGER: 'INSURER_PLAN_MANAGER',
    INSURER_OTHER_ADMIN: 'INSURER_OTHER_ADMIN',
    INSURER_ETC: 'INSURER_ETC',
}

export const Permissions = {
    DASHBOARD_VIEW: 'DASHBOARD_VIEW',
    REPORT_VIEW: 'REPORT_VIEW',
    ORG_MANAGE: 'ORG_MANAGE',
    USER_INVITE: 'USER_INVITE',
    REQUEST_CREATE: 'REQUEST_CREATE',
    REQUEST_REASSIGN: 'REQUEST_REASSIGN',
    REQUEST_CANCEL: 'REQUEST_CANCEL',
    REQUEST_COMPLETE: 'REQUEST_COMPLETE',
    NOTICE_CREATE: 'NOTICE_CREATE',
    NOTICE_APPROVE: 'NOTICE_APPROVE',
    NOTICE_SEND: 'NOTICE_SEND',
    NOTICE_LOG_VIEW: 'NOTICE_LOG_VIEW',
    TEMPLATE_MANAGE: 'TEMPLATE_MANAGE',
    COUNTERPART_VIEW: 'COUNTERPART_VIEW',
    COUNTERPART_NOTE: 'COUNTERPART_NOTE',
}

// 역할별 권한 매핑(백엔드 @PreAuthorize 정책과 동기화)
// NOTE: RolePermissions 초기화 도중 RolePermissions를 참조하면 런타임 에러(TDZ) 발생 → 공통 세트를 상수로 분리.
const PERMS_OPERATOR = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_CANCEL,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_APPROVE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.TEMPLATE_MANAGE,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_ADMIN = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_CANCEL,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_APPROVE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_SUBADMIN = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_MANAGER = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_PLANNER = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
]

const PERMS_ETC = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
]

export const RolePermissions = {
    [Roles.OPERATOR]: [...PERMS_OPERATOR],

    // GA
    [Roles.GA_MASTER_ADMIN]: [...PERMS_ADMIN],
    [Roles.GA_MASTER_DEPUTY_ADMIN]: [...PERMS_SUBADMIN],
    [Roles.GA_LEADER]: [...PERMS_ADMIN],
    [Roles.GA_DEPUTY_LEADER]: [...PERMS_SUBADMIN],
    [Roles.GA_BRANCH_MANAGER]: [...PERMS_ADMIN],
    [Roles.GA_DEPUTY_BRANCH_MANAGER]: [...PERMS_SUBADMIN],
    [Roles.GA_OTHER_ADMIN]: [...PERMS_ADMIN],
    [Roles.GA_MANAGER]: [...PERMS_MANAGER],
    [Roles.GA_PLANNER]: [...PERMS_PLANNER],
    [Roles.GA_ETC]: [...PERMS_ETC],

    // INSURER
    [Roles.INSURER_MASTER_ADMIN]: [...PERMS_ADMIN],
    [Roles.INSURER_MASTER_DEPUTY_ADMIN]: [...PERMS_SUBADMIN],
    [Roles.INSURER_LEADER]: [...PERMS_ADMIN],
    [Roles.INSURER_DEPUTY_LEADER]: [...PERMS_SUBADMIN],
    [Roles.INSURER_BRANCH_MANAGER]: [...PERMS_ADMIN],
    [Roles.INSURER_DEPUTY_BRANCH_MANAGER]: [...PERMS_SUBADMIN],
    [Roles.INSURER_OTHER_ADMIN]: [...PERMS_ADMIN],
    [Roles.INSURER_MANAGER]: [...PERMS_MANAGER],
    [Roles.INSURER_EDUCATION_MANAGER]: [...PERMS_MANAGER],
    [Roles.INSURER_PLAN_MANAGER]: [...PERMS_MANAGER],
    [Roles.INSURER_ETC]: [...PERMS_ETC],
}

// 한글 라벨 매핑
export const RoleLabels = {
    [Roles.OPERATOR]: '운영자',
    [Roles.GA_MASTER_ADMIN]: 'GA 마스터 관리자',
    [Roles.GA_MASTER_DEPUTY_ADMIN]: 'GA 마스터 부관리자',
    [Roles.GA_LEADER]: 'GA 사업단장',
    [Roles.GA_DEPUTY_LEADER]: 'GA 사업부단장',
    [Roles.GA_MANAGER]: '총무/관리매니저',
    [Roles.GA_PLANNER]: '설계사',
    [Roles.GA_BRANCH_MANAGER]: 'GA 지점장',
    [Roles.GA_DEPUTY_BRANCH_MANAGER]: 'GA 부지점장',
    [Roles.GA_OTHER_ADMIN]: 'GA 기타 관리자',
    [Roles.GA_ETC]: '기타 GA 담당자',
    [Roles.INSURER_MANAGER]: '원수사 매니저',
    [Roles.INSURER_MASTER_ADMIN]: '원수사 마스터 관리자',
    [Roles.INSURER_MASTER_DEPUTY_ADMIN]: '원수사 마스터 부관리자',
    [Roles.INSURER_LEADER]: '원수사 사업단장',
    [Roles.INSURER_DEPUTY_LEADER]: '원수사 사업부단장',
    [Roles.INSURER_BRANCH_MANAGER]: '원수사 지점장',
    [Roles.INSURER_DEPUTY_BRANCH_MANAGER]: '원수사 부지점장',
    [Roles.INSURER_EDUCATION_MANAGER]: '원수사 교육매니저',
    [Roles.INSURER_PLAN_MANAGER]: '원수사 설계매니저',
    [Roles.INSURER_OTHER_ADMIN]: '원수사 기타 관리자',
    [Roles.INSURER_ETC]: '기타 원수사 담당자',
}

export function getRoleLabel(role) {
    try {
        const stored = typeof window !== 'undefined' ? localStorage.getItem('meta.roles') : null
        if (stored) {
            const arr = JSON.parse(stored)
            const found = Array.isArray(arr) ? arr.find((r) => r.code === role) : null
            if (found && found.labelKo) return found.labelKo
        }
    } catch { }
    return RoleLabels[role] || role
}

export function getRoleLabels(roles) {
    if (!Array.isArray(roles)) return []
    return roles.map((r) => getRoleLabel(r))
}

export function getUserRoles(user) {
    return Array.isArray(user?.roles) ? user.roles : []
}

export function getUserPermissions(user) {
    const roles = getUserRoles(user)
    const set = new Set()
    roles.forEach((r) => {
        const perms = RolePermissions[r] || []
        perms.forEach((p) => set.add(p))
    })
    return Array.from(set)
}

export function hasAnyRole(user, roles) {
    const userRoles = getUserRoles(user)
    return roles.some((r) => userRoles.includes(r))
}

export function hasAllRoles(user, roles) {
    const userRoles = getUserRoles(user)
    return roles.every((r) => userRoles.includes(r))
}

export function hasPermission(user, permission) {
    const perms = getUserPermissions(user)
    return perms.includes(permission)
}

export function hasAnyPermission(user, permissions) {
    const perms = getUserPermissions(user)
    return permissions.some((p) => perms.includes(p))
}


